import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Baseproperties } from '../../utility/baseproperties';
import { Observable } from 'rxjs/internal/Observable';
import { Router } from '@angular/router';
import { Currency } from "../../utility/modals";

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  constructor(private httpClient: HttpClient, private route: Router) { }

  baseproperties: Baseproperties = new Baseproperties();
  private baseURL = `${new Baseproperties().gatewayBaseURL}/common`;


  scrollHeight: string = '340.8px'; // Set your common scroll height here

  downloadexcel_text = "Please download this Excel data. It will be saved in your Download directory by default."
  downloadexcelformate_text = "Please download this Excel Format. It will be saved in your Download directory by default. Please check for the latest file that is downloaded since Excel does a version control if the file with the same name exists. Open the Excel file and enter the requested information in the columns provided."
  excelformate_text = "Please download this Excel Format. It will be saved in your Download directory by default. Please check for the latest file that is downloaded since Excel does a version control if the file with the same name exists. Open the Excel file and enter the requested information in the columns provided."

  getCurrencyList(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/currency/getcurrencylist`);
  }

  createCurrency(currencydata): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/currency/addcurrencydoc`, currencydata);
  }

  getcurrency(id: number): Observable<Currency> {
    return this.httpClient.get<Currency>(`${this.baseURL}/currency/getcurrency/${id}`);
  }

  modifyCurrencyData(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/currency/modifyCurrencyData`, payload);
  }

  currencyDataExcel() {
    return this.httpClient.get(`${this.baseURL}/currency/exceldata`, { responseType: 'blob' });

  }

  getConfiguration(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.baseURL}/currency/getconfiguration`);
  }


}
